import { render, staticRenderFns } from "./CollectMaxDetail.vue?vue&type=template&id=13b671a0&scoped=true&"
import script from "./CollectMaxDetail.vue?vue&type=script&lang=js&"
export * from "./CollectMaxDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectMaxDetail.vue?vue&type=style&index=0&id=13b671a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b671a0",
  null
  
)

export default component.exports